import { makeStorage } from './makeStorage';

export type OfflineStorage = ReturnType<typeof makeStorage>;

export const offlineStorage: any = makeStorage();
